import React from 'react';
import { Box, ChevronDownIcon, ChevronUpIcon } from '@common-fe/common-fe';

interface Props {
  children?: React.ReactNode;
  isExpanded: boolean;
  setExpanded: (expanded: boolean) => void;
  testId?: string;
}

export const ExpandableHeader: React.FC<Props> = ({ children, isExpanded, setExpanded, testId }) => {
  return (
    <Box
      direction="row"
      align="center"
      data-testId={`ExpandableHeader_${testId}_wrapper`}
    >
      <Box
        data-testId={`ExpandableHeader_${testId}_button`}
        justify="center"
        align="center"
        direction="row"
        onClick={() => setExpanded(!isExpanded)}
      >
        {isExpanded ? (
          <ChevronUpIcon color="textTitle" />
        ) : (
          <ChevronDownIcon color="textTitle" />
        )}
      </Box>
      {children}
    </Box>
  );
};
